// extracted by mini-css-extract-plugin
export default {"productCarousel":"_Y-z"};